module.exports = __webpack_public_path__ + "img/float2.1bb41092.svg";